import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import taskReducer from './slices/taskSlice'
import supportChatReducer from './slices/supportChatSlice'
import scheduledTaskReducer from './slices/scheduledTaskSlice'

const store = configureStore({
  reducer: {
    auth: authReducer,
    task: taskReducer,
    supportChat: supportChatReducer,
    scheduledTask: scheduledTaskReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store
